module.exports = __webpack_public_path__ + "media/smile-2.afe1f5b6.mp3";